var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#4DA0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8453 13.5C25.2678 13.7625 24.6453 13.935 24.0003 14.0175C24.6603 13.62 25.1703 12.99 25.4103 12.2325C24.7878 12.6075 24.0978 12.87 23.3703 13.02C22.7778 12.375 21.9453 12 21.0003 12C19.2378 12 17.7978 13.44 17.7978 15.2175C17.7978 15.4725 17.8278 15.72 17.8803 15.9525C15.2103 15.8175 12.8328 14.535 11.2503 12.5925C10.9728 13.065 10.8153 13.62 10.8153 14.205C10.8153 15.3225 11.3778 16.3125 12.2478 16.875C11.7153 16.875 11.2203 16.725 10.7853 16.5V16.5225C10.7853 18.0825 11.8953 19.3875 13.3653 19.68C12.8933 19.8092 12.3978 19.8271 11.9178 19.7325C12.1215 20.3719 12.5204 20.9313 13.0585 21.3322C13.5966 21.7331 14.2469 21.9553 14.9178 21.9675C13.7805 22.8678 12.3708 23.3545 10.9203 23.3475C10.6653 23.3475 10.4103 23.3325 10.1553 23.3025C11.5803 24.2175 13.2753 24.75 15.0903 24.75C21.0003 24.75 24.2478 19.845 24.2478 15.5925C24.2478 15.45 24.2478 15.315 24.2403 15.1725C24.8703 14.7225 25.4103 14.1525 25.8453 13.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7c38d8f6aaef619b340239e24ba6f695.svg";
export { ForwardRef as ReactComponent };